import React from 'react'
import { IconClose, IconOpen } from "../../../../components/Icons/Icons"
import StatusBadge from "../../../../components/StatusBadge/StatusBadge"

const UserStatusCell = ({ statusObj, arrow = false, isOpen, outlined = false }) => {
  return (
    <StatusBadge
      label={statusObj?.label}
      bgColor={statusObj?.bgColor}
      textColor={statusObj?.textColor}
      width={arrow ? "w-[115px]" : "w-[94px]"}
      showArrow={arrow}
      isOpen={isOpen}
      outlined={outlined}
    />
  )
}

export default UserStatusCell
